import React from "react";

export const AppContext = React.createContext({ isLoggedIn: false, user: {} });
export const CampaignContext = React.createContext({ isLoading: true });
export const FormContext = React.createContext();
